import React, { useContext, useEffect, useState } from "react";

import AddLink from "../components/AddLink";
import Breadcrumb from "../components/Breadcrumb";
import MyLink from "../components/MyLink";

import SideMenu from "../components/SideMenu";
import Navbar from "../components/Navbar";
import { AuthContext } from "../context/AuthContext";

function Link() {
  const { userData } = useContext(AuthContext);
  const [list, setList] = useState([]);
  useEffect(() => {
    document.title = "All Link";
    return () => {
      document.title = "Flipcard";
    };
  }, []);

  useEffect(() => {
    const groupBy = (element, key) => {
      return element.reduce((value, x) => {
        (value[x[key]] = value[x[key]] || []).push(x);
        return value;
      }, {});
    };

    const groupArray = groupBy(userData.link, "section");
    const toArray = Object.values(groupArray);

    const sortArray = toArray.sort(function (a, b) {
      // ASC  -> a.length - b.length ||  DESC -> b.length - a.length
      return a.length - b.length;
    });

    let sectionList = [];
    sortArray.forEach((i) => {
      if (i[0].section !== "") {
        sectionList.push(i[0].section);
      }
    });
    const ascendingList = sectionList.sort();
    setList(ascendingList);
  }, [userData]);

  return (
    <>
      {userData && (
        <>
          <Navbar />
          <div className="content">
            <div className="side-left">
              <SideMenu />
            </div>
            <div className="side-right">
              <Breadcrumb title="All Link" />
              <AddLink list={list} />
              <MyLink list={list} />
            </div>
          </div>
        </>
      )}
    </>
  );
}

export default Link;
